import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_SHIPPING_ADDRESS } from "../../../api/queryKeys";
import { QueryUserMailingAddressResponse } from "../../../types";

export const getMailingAddress = () =>
  api
    .get<QueryUserMailingAddressResponse>(QUERY_SHIPPING_ADDRESS)
    .then((res) => res.data);

export default function useGetMailingAddress() {
  return useQuery([QUERY_SHIPPING_ADDRESS], getMailingAddress);
}
